import axios from "axios";

const instance = axios.create({
  baseURL: "/api"
});

/**
 *
 * parse error response
 */
function parseError(messages) {
  // error
  if (messages) {
    if (messages instanceof Array) {
      return Promise.reject({ messages: messages });
    } else {
      return Promise.reject({ messages: [messages] });
    }
  } else {
    return Promise.reject({ messages: ["An error has occurred..."] });
  }
}

/**
 * parse response
 */
function parseBody(response) {
  //  if (response.status === 200 && response.data.status.code === 200) { // - if use custom status code
  if (response.status === 200) {
    return response.data;
  } else {
    return this.parseError(response.data.messages);
  }
}

// response parse
instance.interceptors.response.use(
  response => {
    return parseBody(response);
  },
  error => {
    console.warn("Error status", error.response.status);
    if (error.response.status === 403) {
      // window.location.href = "/";
    }
    // return Promise.reject(error)
    if (error.response) {
      return parseError(error.response.data);
    } else {
      return Promise.reject(error);
    }
  }
);

export default instance;
